import { Box, Button, Stack } from '@mui/material';
import React, { useMemo } from 'react';
import { FC, useEffect, useState } from 'react';
import { constructHierarchyArray, extractIds } from './TreeNavigatrionHelper';
import { useApplication } from '../../../../context/ApplicationContext';
import MuiDialog from '../../mui-dialog/MuiDialog';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SendIcon from '@mui/icons-material/Send';
import { useLocation } from 'react-router-dom';
import { APIS } from '../../../../lib/constants/apis';
import { get } from 'lodash';
import { LOCATION_API_PATH } from '../../../../lib/constants/constant';
import { GetFieldErrors } from '../../../../lib/validation/ApplicationValidator';

type TreeViewNavigationProps = {
	treeStructure: any;
	currentNode: string[];
	handleNavigation: (nodeIds: string[], buttonClick?: string) => void;
	hasCurrentContentError: () => boolean;
	validateCompleteForm: () => void;
};
const TreeNavigationButtons: FC<TreeViewNavigationProps> = ({
	treeStructure,
	currentNode,
	handleNavigation,
	hasCurrentContentError,
	validateCompleteForm,
}) => {
	const location = useLocation();
	const { application, saveApplication, readOnly } = useApplication();
	const [previousNodes, setPreviousNodes] = useState<string[]>(['1']);
	const [nextNodes, setNextNodes] = useState<string[]>(['1']);
	const [hasError, setHasError] = useState(false);

	const [submitDialogOpen, setSubmitDialogOpen] = useState<boolean>(false);

	const handleSubmitApp = async () => {
		setSubmitDialogOpen(false);
		saveApplication(true);
	};

	const DialogTitle = useMemo(() => {
		switch (get(location, LOCATION_API_PATH)) {
			case APIS.Zuwendungsantrag:
				return 'Antrag einreichen';
			case APIS.Mittelabruf:
				return 'Mittelabruf einreichen';
			case APIS.Verwendungsnachweis:
				return 'Verwendungsnachweis einreichen';
			// case APIS.Zwischenbericht:
			// 	return 'Zwischenbericht einreichen';
			// case APIS.Abschlussbericht:
			// 	return 'Abschlussbericht einreichen';
			default:
				return 'Antrag einreichen';
		}
	}, [location]);
	const DialogContent = useMemo(() => {
		switch (get(location, LOCATION_API_PATH)) {
			case APIS.Zuwendungsantrag:
				return 'Wenn Sie alle Eingaben überprüft haben, können Sie bestätigen, dass Sie den Antrag einreichen möchten.';
			case APIS.Mittelabruf:
				return 'Wenn Sie alle Eingaben überprüft haben, können Sie bestätigen, dass Sie den Mittelabruf einreichen möchten?';
			case APIS.Verwendungsnachweis:
				return 'Wenn Sie alle Eingaben überprüft haben, können Sie bestätigen, dass Sie den Verwendungsnachweis einreichen möchten?';
			// case APIS.Zwischenbericht:
			// 	return 'Sind Sie sicher, dass Sie den Zwischenbericht einreichen möchten?';
			// case APIS.Abschlussbericht:
			// 	return 'Sind Sie sicher, dass Sie den Abschlussbericht einreichen möchten?';
			default:
				return 'Wenn Sie alle Eingaben überprüft haben, können Sie bestätigen, dass Sie den Antrag einreichen möchten.';
		}
	}, [location]);

	useEffect(() => {
		if (!currentNode || currentNode.length === 0) return;

		const allNodesIdsArr = extractIds(treeStructure);
		const currentNodeStr = currentNode[currentNode.length - 1];
		const currentNodeIndex = allNodesIdsArr.findIndex((ele: any) => ele === currentNodeStr);

		if (currentNodeIndex === -1) return;
		let prevNodeStr = allNodesIdsArr[currentNodeIndex - 1];
		let nextNodeStr = allNodesIdsArr[currentNodeIndex + 1];

		// Update state
		setPreviousNodes(constructHierarchyArray(prevNodeStr));
		setNextNodes(constructHierarchyArray(nextNodeStr));
	}, [treeStructure, currentNode]);

	const hasAnyErrorInForm = (): boolean => {
		const errorList = GetFieldErrors(treeStructure, application, readOnly);
		return errorList.length > 0;
	};

	const einreichen = () => {
		setSubmitDialogOpen(true);
		hasCurrentContentError();
		validateCompleteForm();
		setHasError(hasAnyErrorInForm());
	};

	return (
		<>
			<MuiDialog
				open={submitDialogOpen}
				onClose={() => setSubmitDialogOpen(false)}
				onConfirm={() => handleSubmitApp()}
				title={hasError ? 'Fehler im formular' : DialogTitle}
				content={hasError ? 'Es befinden Sich noch Fehler im Formular' : DialogContent}
				hasError={hasError}
			/>
			<Box
				sx={{
					position: 'sticky',
					bottom: '4rem',
					marginTop: 'auto',
				}}
			>
				<Stack
					sx={{ mt: '2rem' }}
					direction={'row'}
					justifyContent={'space-between'}
				>
					<Button
						variant="backButton"
						sx={{ ml: '-9.5rem' }}
						disabled={previousNodes[0] === undefined}
						onClick={() => handleNavigation([], 'previous')}
						startIcon={<ArrowBackIcon />}
					>
						Zurück
					</Button>

					{nextNodes[0] !== undefined ? (
						<Button sx={{ mr: '-9.5rem' }} endIcon={<ArrowForwardIcon />} onClick={() => handleNavigation([], 'next')}>
							Weiter
						</Button>
					) : (
						<>
							{!readOnly && (
								<Button sx={{ mr: '-11rem' }} endIcon={<SendIcon />} onClick={() => einreichen()}>
									Einreichen
								</Button>
							)}
						</>
					)}
				</Stack>
			</Box>
		</>
	);
};
export default TreeNavigationButtons;
